import { render, staticRenderFns } from "./Motion.vue?vue&type=template&id=a7a0dd6e&scoped=true&"
import script from "./Motion.vue?vue&type=script&lang=ts&"
export * from "./Motion.vue?vue&type=script&lang=ts&"
import style0 from "./Motion.vue?vue&type=style&index=0&id=a7a0dd6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7a0dd6e",
  null
  
)

export default component.exports